import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import logo from "../assets/logo.png";

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#2C3E50" }}>
      <Container maxWidth="xl">
        <Toolbar
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            width: "100%",
            py: 0,
            px: 0,
          }}
        >
          {/* Left section (Logo + Text after logo) */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: isMobile ? "100%" : "auto",
              justifyContent: isMobile ? "center" : "flex-start",
              mb: isMobile ? 1 : 0,
            }}
          >
            <img src={logo} alt="Logo" style={{ height: 40 }} />
            <Typography
              variant={isSmallMobile ? "subtitle2" : "subtitle1"}
              sx={{ ml: 2 }}
              noWrap
            >
              Car Accident Counsel
            </Typography>
          </Box>

          {/* Center Title */}
          <Typography
            variant={isSmallMobile ? "subtitle2" : "subtitle1"}
            align="center"
            sx={{
              ml: isMobile ? "" : "-20%",
              flexGrow: isMobile ? 0 : 1,
              fontSize: {
                xs: "0.875rem",
                sm: "1rem",
                md: "1.1rem",
              },
              fontWeight: "medium",
            }}
          >
            You May be Entitled to Maximum Accident Compensation
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
